import PropTypes from 'prop-types'
import { Card } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    color: theme.palette.white.main,
  },
}))

const LoginLayout = ({ children }) => {
  const classes = useStyles()

  return (
    <div id="wrapper">
      <main className="loginMain">
        <Card className={classes.root}>
          <div className="custom-shape-divider-top-1633695843">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
          {children}
        </Card>
      </main>
    </div>
  )
}

LoginLayout.propTypes = {
  children: PropTypes.any,
}

export default LoginLayout
